import { 
     SEARCH_KEYWORD,
     SEARCH_KEYWORD_WITH_YEAR, 
     SEARCH_KEYWORD_COUNTRY_CHANGE,
     PROFILE_SEARCH_CHANGE,
     SEARCH_PROFILES,
     SEARCH_EXPERTS_AFFILIATION,
     AFFILIATION_SEARCH_CHANGE,
     TERM_SEARCH_CHANGE
    } from '../actions/types';

const initialState = {
    topExperts: [],
    total: 0,
    filter: {
        year: { label: 'Anytime', value: 0 },
        country: { value: 'All', label: 'All' }
    },
    isProfileSearchActive: false,
    isAffiliationSearchActive: false,
    profiles: {
        keyword: '',
        results: []
    },
    affiliationResults: {
        keyword: '',
        results: []
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_KEYWORD:
            return {
                ...state,
                topExperts: action.payload.topExperts || [],
                keyword: action.payload.keyword,
                total: action.payload.total,
                filter: {
                    year: { label: 'Anytime', value: 0 },
                    country: { value: 'All', label: 'All' }
                }
            }
            break;
        case SEARCH_KEYWORD_WITH_YEAR:
            return {
                ...state,
                topExperts: action.payload.topExperts || [],
                total: action.payload.total,
                filter: {
                    ...state.filter,
                    year: action.payload.year || { label: 'Anytime', value: 0 },
                }
            }
        case SEARCH_KEYWORD_COUNTRY_CHANGE:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    country: action.payload.country|| { value: 'All', label: 'All' },
                }
            }
        case PROFILE_SEARCH_CHANGE:
            return {
                ...state,
                isProfileSearchActive: action.payload.isProfileSearchActive,
                isAffiliationSearchActive: false
            }
        case SEARCH_PROFILES :
            return {
                ...state,
               profiles: action.payload.profiles || [],
            }
            break;
        case AFFILIATION_SEARCH_CHANGE:
            return {
                ...state,
                isAffiliationSearchActive: action.payload.isAffiliationSearchActive,
                isProfileSearchActive: false
            }
        case SEARCH_EXPERTS_AFFILIATION:
            return {
                ...state,
                affiliationResults: action.payload.affiliationResults || [],  
            }
            break;
        case TERM_SEARCH_CHANGE:
            return {
                ...state,
                isAffiliationSearchActive: false,
                isProfileSearchActive: false
            }
        default:
            return state;
            break;
    }
}
